import { authQueryKeys as e } from "../queries/state/useAuthQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { authApi as r } from "@maat/api-main";
//#region src/password/useResetPasswordMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: r.resetPassword,
		retry: !1,
		onSuccess: (t) => {
			t.user && (i.invalidateQueries({ queryKey: e.me() }), i.invalidateQueries({ queryKey: e.state() }), i.removeQueries({ queryKey: ["permission"] }));
		}
	});
};
//#endregion
export { i as useResetPasswordMutation };
